import React from 'react';

function SignedOut() {
  return (
    <div style={{
      background: '#0b132b',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{ 
        textAlign: 'center', 
        maxWidth: '500px',
        padding: '40px'
      }}>
        <div style={{
          width: '60px',
          height: '60px',
          background: '#00d4aa',
          borderRadius: '50%',
          margin: '0 auto 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          color: '#0b132b'
        }}>
          ✓
        </div>
        
        <h1 style={{ 
          color: '#00d4aa', 
          marginBottom: '16px',
          fontSize: '28px',
          fontWeight: '600'
        }}>
          You are now signed out
        </h1>
        
        <p style={{ 
          marginBottom: '32px', 
          lineHeight: '1.6',
          color: '#a0a9c0',
          fontSize: '16px'
        }}>
          Your session has been ended securely. To access your StableGuard dashboard again, 
          please sign back in below.
        </p>
        
        <button
          onClick={() => window.location.href = 'https://stableguard.org'}
          style={{
            background: '#00d4aa',
            color: '#0b132b',
            border: 'none',
            padding: '14px 28px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '16px',
            transition: 'all 0.2s ease'
          }}
          onMouseOver={(e) => e.target.style.background = '#00b8a0'}
          onMouseOut={(e) => e.target.style.background = '#00d4aa'}
        >
          Return to StableGuard
        </button>
      </div>
    </div>
  );
}

export default SignedOut;
